import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const NavClock = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12,21c-4.962,0-9-4.038-9-9s4.038-9,9-9s9,4.038,9,9S16.963,21,12,21z M12,5c-3.86,0-7,3.14-7,7\n\t        s3.14,7,7,7s7-3.14,7-7S15.86,5,12,5z" }),
    React.createElement("path", { d: "M16.488,12.65h-5.191V7.459c0-0.552,0.448-1,1-1c0.552,0,1,0.448,1,1v3.191h3.191\n\t        c0.553,0,1,0.448,1,1C17.488,12.202,17.041,12.65,16.488,12.65z" })), 'NavClock');
export default NavClock;
